"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapped = void 0;
var _react = _interopRequireWildcard(require("react"));
var _box = require("@oneloop/box");
var _tags = require("@oneloop/tags");
var _excluded = ["items", "fnClose", "widthRestItemsWindow", "printKey", "tagVariant", "clickFn", "idKey"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-unused-expressions */ /* eslint-disable multiline-ternary */
var wrappedReducer = function wrappedReducer(state, action) {
  switch (action.type) {
    case 'ADD_REST_ITEM':
      return _objectSpread(_objectSpread({}, state), {}, {
        restItems: [].concat(_toConsumableArray(state.restItems), [action.payload])
      });
    case 'DELETE_REST_ITEM':
      return _objectSpread(_objectSpread({}, state), {}, {
        restItems: []
      });
  }
};
var Wrapped = exports.Wrapped = function Wrapped(_ref) {
  var items = _ref.items,
    fnClose = _ref.fnClose,
    widthRestItemsWindow = _ref.widthRestItemsWindow,
    printKey = _ref.printKey,
    tagVariant = _ref.tagVariant,
    clickFn = _ref.clickFn,
    _ref$idKey = _ref.idKey,
    idKey = _ref$idKey === void 0 ? 'id' : _ref$idKey,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useReducer = (0, _react.useReducer)(wrappedReducer, {
      restItems: []
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    store = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showRestItem = _useState2[0],
    setShowRestItems = _useState2[1];
  var Ref = (0, _react.useRef)(null);
  var refElements = (0, _react.useRef)([]);
  var RefItemsWindow = (0, _react.useRef)(null);
  var widthWrapper = 0;
  var widthElements = 0;
  var elements = 0;
  (0, _react.useEffect)(function () {
    elements = Ref.current.children;
    widthWrapper = Ref.current.offsetWidth;
    var _loop = function _loop(index) {
      if (!refElements.current.find(function (elem) {
        return elem.id === elements[index].id;
      }) && !elements[index].className.includes('numberTag')) {
        refElements.current.push(_objectSpread(_objectSpread({}, elements[index]), {}, {
          width: elements[index].offsetWidth + 5,
          id: elements[index].id
        }));
      }
      if (!elements[index].className.includes('numberTag')) {
        widthElements = widthElements + refElements.current[index].width;
      }
      if (widthElements > widthWrapper - 30) {
        elements[index].style.display = elements[index].className.includes('numberTag') ? 'inline-flex' : 'none';
        if (!elements[index].className.includes('numberTag')) {
          if (!store.restItems.find(function (elem) {
            return elem[idKey] === items[index][idKey];
          })) {
            dispatch({
              type: 'ADD_REST_ITEM',
              payload: items[index]
            });
          }
        }
      }
    };
    for (var index = 0; index < elements.length; index++) {
      _loop(index);
    }
  }, [items]);
  (0, _react.useEffect)(function () {
    var handleClick = function handleClick(event) {
      var _RefItemsWindow$curre, _event$target$classNa;
      if (!((_RefItemsWindow$curre = RefItemsWindow.current) !== null && _RefItemsWindow$curre !== void 0 && _RefItemsWindow$curre.contains(event.target)) && !((_event$target$classNa = event.target.className) !== null && _event$target$classNa !== void 0 && _event$target$classNa.includes('numberTag'))) {
        setShowRestItems(false);
      }
    };
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, [showRestItem]);
  var handleShowRestItems = function handleShowRestItems() {
    setShowRestItems(!showRestItem);
  };
  var deleteRestItem = function deleteRestItem(item) {
    refElements.current = refElements.current.filter(function (elem) {
      return elem.id !== item[idKey];
    });
    dispatch({
      type: 'DELETE_REST_ITEM'
    });
    fnClose(item);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    __css: {
      display: 'block',
      alignItems: 'center',
      gap: '5px',
      overflow: widthWrapper,
      whiteSpace: 'nowrap'
    }
  }, props, {
    ref: Ref
  }), items.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_tags.Tags, {
      key: item[idKey] + i,
      id: item[idKey],
      variant: tagVariant,
      closeIcon: fnClose ? function () {
        return deleteRestItem(item);
      } : false,
      style: {
        marginRight: '5px'
      },
      onClick: item[clickFn]
    }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
      as: "p",
      __css: {
        maxWidth: '250px',
        overflow: 'hidden',
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis'
      }
    }, item[printKey]));
  }), store.restItems.length > 0 ? /*#__PURE__*/_react["default"].createElement(_tags.Tags, {
    variant: tagVariant,
    className: "numberTag",
    onClick: handleShowRestItems
  }, "+".concat(store.restItems.length)) : ''), showRestItem && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    ref: RefItemsWindow,
    __css: {
      padding: '12px 14px',
      position: 'absolute',
      top: '30px',
      background: '#FFFFFF',
      boxShadow: '4px 4px 12px rgba(87, 95, 99, 0.1)',
      borderRadius: '8px',
      width: widthRestItemsWindow,
      zIndex: 100
    }
  }, store.restItems.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_tags.Tags, {
      key: item[idKey] + i,
      id: item[idKey],
      variant: tagVariant,
      closeIcon: fnClose ? function () {
        return deleteRestItem(item);
      } : false,
      style: {
        marginRight: '5px',
        marginBottom: '5px'
      },
      onClick: item[clickFn]
    }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
      as: "p",
      __css: {
        maxWidth: '250px',
        overflow: 'hidden',
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis'
      }
    }, item[printKey]));
  })));
};